import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function listingRestaurants () {

	// Skip containers already initialised (eg. re-running after an ACF
	// block preview refresh in the editor - see hook below)
	const swipers = document.querySelectorAll('section.listing-restaurants .swiper:not(.swiper-initialized)');

	if (! swipers.length) return;



	// Init swiper
	swipers.forEach(function (container) {

		const section = container.closest('section');

		new Swiper (container, {
			modules: [Navigation, Pagination],
			loop: false,
			snapToSlideEdge: true,
			spaceBetween: 24,
			breakpoints: {
				0:    { slidesPerView: 1.2 },
				540:  { slidesPerView: 1.5 },
				768:  { slidesPerView: 2.2 },
				1024: { slidesPerView: 3.2 },
				1364: { slidesPerView: 4.2 },
			},
			pagination: {
				el: section.querySelector('.swiper-pagination'),
				type: 'progressbar',
			},
			navigation: {
				prevEl: section.querySelector('.swipe-prev'),
				nextEl: section.querySelector('.swipe-next'),
			},
		});

	});

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=listing-restaurants', listingRestaurants);
}
